import { apiClientConfig } from "@/utils/api-utils"
import { MedicalApi } from "@vitable/asclepius-api-client-ts"

const state = () => ({
  ohrCounts: {
    pending: 0,
    missing: 0
  }
})

const getters = {
  totalOhrsNeedingAttention: (state) => {
    return state.ohrCounts.pending + state.ohrCounts.missing
  }
}

const actions = {
  refreshAllCounts({ dispatch }) {
    dispatch("getPendingOhrsCount")
    dispatch("getMissingOhrsCount")
  },

  async getPendingOhrsCount({ commit }) {
    try {
      const medicalApi = new MedicalApi(apiClientConfig())
      const response = await medicalApi.listOccupationalHealthRecords({
        pendingApprovalIn: true
      })

      commit("setPendingOhrsCount", {
        pendingOhrsCount: response.data.count
      })
    } catch (e) {
      console.error(`Failed to getPendingOhrsCount - ${e}`)
      throw new Error(e)
    }
  },

  async getMissingOhrsCount({ commit }) {
    try {
      const medicalApi = new MedicalApi(apiClientConfig())
      const response = await medicalApi.listMissingOccupationalHealthRecords()

      commit("setMissingOhrsCount", {
        missingOhrsCount: response.data.count
      })
    } catch (e) {
      console.error(`Failed to getMissingOhrsCount - ${e}`)
      throw new Error(e)
    }
  }
}

const mutations = {
  setPendingOhrsCount(state, { pendingOhrsCount }) {
    state.ohrCounts.pending = pendingOhrsCount
  },

  setMissingOhrsCount(state, { missingOhrsCount }) {
    state.ohrCounts.missing = missingOhrsCount
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
